import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'lookupValue'
})
export class LookupValuePipe implements PipeTransform {

  transform(id: any, array: any[], idField: string, valueField: string): string {
    let found = null;
    if (id && array) {
      found = array.find(item => item[idField] === id);
    } 
    return found ? found[valueField] : '';
  }

}